import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import "./LandingPageV3.css";

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function ResetPassword() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";
  const [newPassword, setNewPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async () => {
    if (newPassword.length < 6) { toast.error("Password must be at least 6 characters"); return; }
    if (newPassword !== confirm) { toast.error("Passwords do not match"); return; }
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/auth/reset-password`, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, new_password: newPassword }),
      });
      const data = await res.json();
      if (!res.ok) {
        toast.error(typeof data.detail === "string" ? data.detail : "Reset failed — this link may be invalid or expired.");
        setLoading(false);
        return;
      }
      setDone(true);
      toast.success("Password reset! You can now sign in.");
    } catch { toast.error("Connection error"); }
    setLoading(false);
  };

  return (
    <div className="lpv3" data-testid="reset-password-page" style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
      <div style={{ width: "100%", maxWidth: 380, background: "#fff", borderRadius: 14, boxShadow: "0 10px 40px rgba(0,0,0,0.08)", border: "1px solid #eee", padding: 28 }}>
        <div style={{ textAlign: "center", marginBottom: 8 }}>
          <i className="ti ti-key" style={{ color: "#6C4BF4", fontSize: 34 }} aria-hidden="true" />
          <h1 style={{ fontSize: 20, fontWeight: 800, margin: "8px 0 2px" }}>Reset your password</h1>
        </div>

        {!token ? (
          <div className="py-4 text-center">
            <p className="text-sm text-red-600" data-testid="reset-no-token">This reset link is invalid or incomplete. Please request a new one from the login page.</p>
            <button onClick={() => navigate("/login")} className="auth-btn" style={{ marginTop: 16, height: 40 }} data-testid="reset-back-login-btn">Back to Login</button>
          </div>
        ) : done ? (
          <div className="py-4 text-center" data-testid="reset-success">
            <i className="ti ti-circle-check" style={{ color: "#16a34a", fontSize: 40 }} aria-hidden="true" />
            <p className="text-sm font-semibold text-green-700 mt-2">Password reset successfully!</p>
            <p className="text-xs text-gray-500 mt-1">You can now sign in with your new password.</p>
            <button onClick={() => navigate("/login")} className="auth-btn" style={{ marginTop: 16, height: 40 }} data-testid="reset-go-login-btn">Go to Login</button>
          </div>
        ) : (
          <div className="space-y-3 py-2">
            <p className="text-xs text-gray-500 text-center">Choose a new password for your IPOLabs account.</p>
            <input type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} placeholder="New password (min 6 chars)" className="auth-input" style={{ height: 40 }} data-testid="reset-new-password-input" />
            <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="Confirm new password" className="auth-input" style={{ height: 40 }} data-testid="reset-confirm-password-input" />
            <button onClick={submit} disabled={loading} className="auth-btn" style={{ height: 42 }} data-testid="reset-submit-btn">
              {loading ? <i className="ti ti-loader-2" style={{ animation: "spin 1s linear infinite" }} aria-hidden="true" /> : "Reset Password"}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
